export const closeAppleWebsheet = () => {
  try {
    // @ts-ignore: This is injected by Apple devices
    DataActivationController.doneSelected();
  } catch (e) {
    // TODO: Websheet accessed with non-iOS device - error reporting?
  }
};

export const updateAppleDataPlanAccountWithInfo = (dataPlanInfo: { eid: string; iccid: string }) => {
  try {
    // @ts-ignore: This is injected by Apple devices
    DataActivationController.dataPlanAccountUpdatedWithInfo({
      eid: dataPlanInfo.eid,
      iccid: dataPlanInfo.iccid,
    });
  } catch (e) {
    // TODO: Websheet accessed with non-iOS device - error reporting / page!?
  }
};
